import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  alt?: string;
}

/**
 * The DiveLog wordmark/logo as a PNG (transparent background).
 * Apply size via Tailwind classes on the wrapping element (e.g. `h-8 w-8`).
 */
export function Logo({ className, alt = 'DiveLogApp' }: LogoProps) {
  return (
    <img
      src="/divelog-logo.png"
      alt={alt}
      width={446}
      height={446}
      className={cn('h-6 w-6 object-contain', className)}
      decoding="async"
      loading="eager"
    />
  );
}
